//Libs
import React from "react";
import { Wrapper } from "components/components";

const ResumeReporting = () => {
  return <Wrapper padding="0"></Wrapper>;
};

export default ResumeReporting;
